/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit všechny barvy`
};

const da_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Se alle farver`
};

const de_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Alle Farben anzeigen`
};

const en_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `See all colors`
};

const es_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Ver todos los colores`
};

const fr_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Voir tous les coloris`
};

const hu_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Összes szín megtekintése`
};

const it_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi tutti i colori`
};

const nl_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijk alle kleuren`
};

const pl_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Zobacz wszystkie kolory`
};

const pt_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Ver todas as cores`
};

const sv_see_all_colors = /** @type {(inputs: {}) => string} */ () => {
	return `Visa alla färger`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const see_all_colors = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.see_all_colors(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("see_all_colors", locale)
	if (locale === "cs") return cs_see_all_colors(inputs)
	if (locale === "da") return da_see_all_colors(inputs)
	if (locale === "de") return de_see_all_colors(inputs)
	if (locale === "en") return en_see_all_colors(inputs)
	if (locale === "es") return es_see_all_colors(inputs)
	if (locale === "fr") return fr_see_all_colors(inputs)
	if (locale === "hu") return hu_see_all_colors(inputs)
	if (locale === "it") return it_see_all_colors(inputs)
	if (locale === "nl") return nl_see_all_colors(inputs)
	if (locale === "pl") return pl_see_all_colors(inputs)
	if (locale === "pt") return pt_see_all_colors(inputs)
	return sv_see_all_colors(inputs)
};